// extracted by mini-css-extract-plugin
export default {"tabBar":"ReportsTabBar_tabBar__4yaIJ","tab":"ReportsTabBar_tab__fzCXH","active":"ReportsTabBar_active__7+dkZ"};